import React from 'react';
import {Route, Routes} from "react-router-dom";
import Hydromodul from "./gidromodul/Hydromodul";
import Fao from "./fao/Fao";
const Sfr = () => {

    return (
        <div className="sfrr h-100" style={{position:"relative"}}>
            <Routes>
                <Route path="/*" element={
                    <Hydromodul />
                }/>
                <Route path="/fao/*" element={
                    <Fao />
                }/>
                <Route path="/gidromodul/*" element={
                    <Hydromodul />
                }/>
            </Routes>
        </div>
    );
};

export default Sfr;